import React from 'react';
import '../style-sheet/Experiencia.css';

export default function Experiencia() {
	return (
		<section id='experiencia' className='container-fluid'>
			<div className='row experiencia-container d-flex justify-content-center flex-column ml-1'>
				<p className='titulo-experiencia'>
					La mejor experiencia <em>birrística</em>
				</p>
				<p className='subtitulo-experiencia'>En el confort de tu casa</p>
			</div>
		</section>
	);
}
